import { defineMessages } from 'react-intl';

export default defineMessages({
  notes: {
    id: 'admanagement.property.notes',
    defaultMessage: 'Notes',
  },
});
